import { useEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import UploadFile from "../../Components/UploadFile";
import moment from "moment";
import { useCookies } from "react-cookie";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";

function NewService(props) {
  const apiToken = useContext(TokenContext);
  const [validation, setValidation] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [data, setData] = useState();
  const [name, setName] = useState();
  const [description, setDescription] = useState();
  const [tipoServizio, setTipoServizio] = useState(0);
  const [typeService, setTypeService] = useState();

  const sendService = () => {
    setValidation(true);

    let passedValidation = true;

    let tempData = {};

    if (!name) {
      passedValidation = false;
    } else {
      tempData["name"] = name;
    }

    if (!description) {
      passedValidation = false;
    } else {
      tempData["description"] = description;
    }

    tempData["tipoServizio"] = parseInt(tipoServizio, 10);

    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);
      setData(dataJson);
      if (apiToken) {
        toggleModal(!isOpen);
      }
    }
  };

  useEffect(() => {
    Repo.getTypeService(apiToken)
      .then((response) => {
        setTypeService(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const sendServiceApi = async () => {
    Repo.postInsertService(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/categorie";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <h4>Nuova categoria</h4>
      <div className="card-wrapper card-space">
        <div className="card card-bg card-big roundedCustom">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-6 select-wrapper">
                <label className="form-label" htmlFor="tipoServizio">
                  Tipo servizio
                </label>
                <select
                  id="tipoServizio"
                  name="tipoServizio"
                  value={tipoServizio}
                  onChange={(e) => setTipoServizio(e.target.value)}
                  className="form-control custom-textarea mb-3"
                >
                  {typeService?.length > 0 &&
                    typeService.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.description}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-lg-6">
                <Input
                  id="name"
                  required
                  type="text"
                  label="Nome categoria*"
                  name="Nome categoria*"
                  onChange={(e) => setName(e.target.value)}
                  {...(validation &&
                    !name && {
                      infoText: "Il campo non può essere vuoto!",
                      className: "text-danger error_div",
                    })}
                />
              </div>
              <div className="col-lg-12 mt-3">
                <textarea
                  id="description"
                  required
                  placeholder="Descrizione*"
                  name="Descrizione*"
                  onChange={(e) => setDescription(e.target.value)}
                  {...(validation &&
                    !description && {
                      infoText: "Il campo non può essere vuoto!",
                      className: "text-danger error_div",
                    })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => sendService()}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Inserimento nuova categoria"
        body="Confermi di voler inserire un nuova categoria?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendServiceApi()}
      ></ModalComponent>
    </div>
  );
}

export default NewService;
